import { Form, Row, Col, Button } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setTransactionFilterForm } from "../../../slices/orders/orderSlice";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { PMT_FROM_DATE, PMT_TO_DATE } from "../../../Utils/FilterDateKeys";

const AllTransactionFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.order.transactionFilter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setTransactionFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setTransactionFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const transactionOptions = [
    { value: "SUCCESS", label: "Success" },
    { value: "PENDING", label: "Pending" },
    { value: "FAILED", label: "Failed" },
  ];

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <Form.Control
              type="text"
              placeholder="Search for Code..."
              name="code"
              id="code"
              value={filterForm.code || ""}
              onChange={(e) => handleInputChange(e.target.name, e.target.value)}
            />
          </Form.Group>

          <Form.Group as={Col} className="col-md-3">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[PMT_FROM_DATE]
                  ? new Date(filterForm[PMT_FROM_DATE])
                  : null,
                filterForm[PMT_TO_DATE]
                  ? new Date(filterForm[PMT_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setTransactionFilterForm,
                  PMT_FROM_DATE,
                  PMT_TO_DATE
                )
              }
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-4">
            <Select
              isClearable
              placeholder="Status"
              name="payment_status"
              options={transactionOptions}
              value={
                transactionOptions.find(
                  (itm) => itm.value === filterForm.payment_status
                ) || null
              }
              onChange={(e) => handleInputChange("payment_status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button className="primary-outline" onClick={handleClear}>
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default AllTransactionFilter;
